
import { useState } from 'react';

export default function Home() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      name: "王媽媽",
      content: "孩子在共學趣學習後，寫作能力明顯提升，現在會主動分享生活中的小故事，表達能力也變得更好了！",
      grade: "小三家長"
    },
    {
      name: "李爸爸", 
      content: "老師很有耐心，會針對每個孩子的程度調整教學方式，我家孩子從害怕寫作到現在很期待上課！",
      grade: "小五家長"
    },
    {
      name: "陳媽媽",
      content: "線上小班制真的很棒，孩子有充分的發言機會，老師也能照顧到每個學生的學習狀況。",
      grade: "國一家長"
    },
    {
      name: "張媽媽",
      content: "自從開始學習之後，每個禮拜都期待上課，也會自己找老師推薦的課外讀物！",
      grade: "小四家長"
    },
    {
      name: "林爸爸",
      content: "經過老師的專業指導，在校內外都獲得語文競賽的名次肯定，謝謝老師！",
      grade: "國二家長"
    }
  ];

  const features = [
    {
      icon: "ri-heart-fill",
      title: "學員口碑推薦",
      description: "家長與學生一致好評，見證孩子的成長與進步"
    },
    {
      icon: "ri-book-open-fill", 
      title: "主題式作文沉浸學習",
      description: "獨創主題式教學法，讓孩子在有趣的情境中自然學習"
    },
    {
      icon: "ri-edit-fill",
      title: "培養長期寫作能力",
      description: "不只是技巧訓練，更注重培養孩子對寫作的興趣與熱忱"
    },
    {
      icon: "ri-star-fill",
      title: "超強師資",
      description: "讓優質教育更專業"
    }
  ];

  const philosophies = [
    {
      icon: "ri-global-fill",
      title: "不受地點限制",
      description: "不論何地都可以進行課程"
    },
    {
      icon: "ri-group-fill",
      title: "線上迷你小團班",
      description: "4-6人小班制，確保每位學生都能充分參與"
    },
    {
      icon: "ri-star-fill", 
      title: "專業頂尖師資",
      description: "語文競賽冠軍老師，15年以上教學經驗"
    },
    {
      icon: "ri-computer-fill",
      title: "線上批改系統",
      description: "Google系統即時批改回饋+訂正"
    },
    {
      icon: "ri-gamepad-fill",
      title: "趣味多元主題寫作",
      description: "深受孩子喜愛的互動式教學方式"
    },
    {
      icon: "ri-settings-fill",
      title: "客製化學習",
      description: "特殊需求竭力支持，因材施教"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-pink-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-pink-500" style={{fontFamily: '"Pacifico", serif'}}>
                共學趣線上寫作教室
              </h1>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a href="/" className="text-pink-500 font-medium px-3 py-2 rounded-md text-sm whitespace-nowrap cursor-pointer">首頁</a>
                <a href="/courses" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer">課程介紹</a>
                <a href="/teachers" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer">師資團隊</a>
                <a href="/results" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer">教學成果</a>
                <a href="/trial" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer">免費試聽</a>
              </div>
            </div>
            <div className="md:hidden">
              <button className="text-gray-700 hover:text-pink-500 w-6 h-6 flex items-center justify-center cursor-pointer">
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-pink-50 to-rose-50 py-20 lg:py-32">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-10" 
             style={{backgroundImage: `url('https://public.readdy.ai/ai/img_res/84449eaac4717ab40f5921c395e0d45c.jpg')`}}>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-center lg:text-left">
              <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6">
                點燃孩子的
                <span className="text-pink-500">寫作熱情</span>
              </h1>
              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                共學趣線上寫作教室，讓孩子在快樂中學習，在創作中成長。
                我們相信每個孩子都有無限的創意潛能，只需要正確的引導與啟發。
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <button className="bg-pink-500 text-white px-8 py-4 rounded-full font-semibold hover:bg-pink-600 transition-colors whitespace-nowrap cursor-pointer">
                  立即免費試聽
                </button>
                <button 
                  onClick={() => window.REACT_APP_NAVIGATE('/courses')}
                  className="border-2 border-pink-500 text-pink-500 px-8 py-4 rounded-full font-semibold hover:bg-pink-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  了解課程內容
                </button>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/6a4168e1db81f7a7fb40133af0c991e9/b75e5b975ee60592b48e10c65da188e6.png"
                alt="快樂學習的孩子們"
                className="w-full h-auto rounded-2xl shadow-2xl object-cover"
              />
              <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-lg">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center">
                    <i className="ri-star-fill text-pink-500 text-xl"></i>
                  </div>
                  <div>
                    <p className="font-bold text-gray-900">1000+</p>
                    <p className="text-sm text-gray-600">滿意學員</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              課程四大特色
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              我們致力於提供最優質的線上寫作教育，讓每個孩子都能在快樂中學習成長
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="text-center group hover:transform hover:scale-105 transition-all duration-300">
                <div className="w-40 h-40 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-pink-500 transition-colors">
                  <i className={`${feature.icon} text-6xl text-pink-500 group-hover:text-white transition-colors`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed text-center">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 bg-pink-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              家長真實回饋
            </h2>
            <p className="text-xl text-gray-600">
              聽聽家長們怎麼說我們的課程
            </p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=A%20caring%20Asian%20parent%20sitting%20beside%20their%20elementary%20school%20child%20at%20a%20clean%20desk%2C%20both%20looking%20at%20a%20computer%20screen%20during%20an%20online%20writing%20class.%20The%20parent%20is%20gently%20guiding%20and%20encouraging%20the%20child%20who%20is%20focused%20on%20learning.%20The%20scene%20shows%20a%20minimalist%20home%20learning%20environment%20with%20clean%20background%2C%20natural%20lighting%20creates%20a%20cozy%20atmosphere%20showing%20parental%20involvement%20in%20online%20education.%20Simple%20and%20clean%20composition%20without%20cluttered%20materials%2C%20focusing%20on%20the%20warm%20interaction%20between%20parent%20and%20child.&width=600&height=400&seq=parent-child-clean&orientation=landscape"
                alt="家長陪伴孩子上課"
                className="w-full rounded-2xl shadow-2xl object-cover object-top"
              />
              <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-xl shadow-lg">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center">
                    <i className="ri-heart-fill text-pink-500 text-xl"></i>
                  </div>
                  <div>
                    <p className="font-bold text-gray-900">95%</p>
                    <p className="text-sm text-gray-600">家長滿意度</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="max-w-2xl">
              <div className="bg-white rounded-2xl shadow-lg p-8 lg:p-12">
                <div className="text-center">
                  <div className="w-20 h-20 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <i className="ri-double-quotes-l text-3xl text-pink-500"></i>
                  </div>
                  <p className="text-xl text-gray-700 mb-8 leading-relaxed">
                    {testimonials[currentTestimonial].content}
                  </p>
                  <div className="mb-8">
                    <h4 className="text-lg font-bold text-gray-900">{testimonials[currentTestimonial].name}</h4>
                    <p className="text-pink-500">{testimonials[currentTestimonial].grade}</p>
                  </div>
                  <div className="flex justify-center gap-2">
                    {testimonials.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentTestimonial(index)}
                        className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                          index === currentTestimonial ? 'bg-pink-500' : 'bg-gray-300'
                        }`}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              我們的學習
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              我們堅持以學生為本的教學理念，提供最適合孩子的學習環境
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {philosophies.map((philosophy, index) => (
              <div key={index} className="bg-pink-50 rounded-xl p-8 hover:shadow-lg transition-shadow text-center">
                <div className="w-32 h-32 bg-pink-100 rounded-lg flex items-center justify-center mb-6 mx-auto">
                  <i className={`${philosophy.icon} text-5xl text-pink-500`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">{philosophy.title}</h3>
                <p className="text-gray-600 leading-relaxed text-center">{philosophy.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-pink-500 to-rose-500">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            準備好開始孩子的寫作之旅了嗎？
          </h2>
          <p className="text-xl text-pink-100 mb-8 max-w-2xl mx-auto">
            立即預約免費試聽課程，讓我們一起見證孩子的成長與蛻變
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-pink-500 px-8 py-4 rounded-full font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
              立即免費試聽
            </button>
            <a href="https://lin.ee/3Slg6R2Zx" target="_blank" rel="noopener noreferrer" className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-pink-500 transition-colors whitespace-nowrap cursor-pointer">
              加入官方LINE
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <h3 className="text-2xl font-bold mb-4 text-pink-400" style={{fontFamily: '"Pacifico", serif'}}>
                共學趣線上寫作教室
              </h3>
              <p className="text-gray-400 mb-6 leading-relaxed">
                專業線上寫作教室，致力於培養孩子的寫作能力與創意思維。
                我們相信每個孩

子都有無限潛能，只需要正確的引導。
              </p>
              <div className="flex gap-4">
                <a href="https://lin.ee/3Slg6R2Zx" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors cursor-pointer">
                  <i className="ri-line-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors cursor-pointer">
                  <i className="ri-instagram-fill text-lg"></i>
                </a>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">快速連結</h4>
              <ul className="space-y-2">
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">課程介紹</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">師資團隊</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">教學成果</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">免費試聽</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">聯絡資訊</h4>
              <ul className="space-y-2 text-gray-400">
                <li className="flex items-center gap-2">
                  <i className="ri-line-fill"></i>
                  <a href="https://lin.ee/3Slg6R2Zx" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">@write123</a>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-fill"></i>
                  <span>週一至週日 9:00-21:00</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-global-fill"></i>
                  <span>線上教學，不限地區</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2025 共學趣線上寫作教室. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer ml-2">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
